import {createContext} from 'react';

import {noop} from '@dms/teas';

export const validationCheckerContext = createContext<{
  setValue: (key: string, isValid: boolean) => void;
}>({setValue: noop});
